import Vue from 'vue'
import Vuex from 'vuex'
// import createLogger from 'vuex/dist/logger'
import moment from 'moment'
import createEntitiesPlugin from './entities'

import './echo'

Vue.use(Vuex)

const debug = DEBUG

import VuexORM from '@vuex-orm/core'
import Category from './models/Category'
import categories from './modules/categories'
import Client from './models/Client'
import clients from './modules/clients'
import Department from './models/Department'
import departments from './modules/departments'
import Notification from './models/Notification'
import notifications from './modules/notifications'
import Task from './models/Task'
import tasks from './modules/tasks'
import User from './models/User'
import users from './modules/users'
import Vacation from './models/Vacation'
import vacations from './modules/vacations'

// Create new instance of Database.
const database = new VuexORM.Database()
// Register Model and Module. The First argument is the Model, and second is the Module.
database.register(Category, categories)
database.register(Client, clients)
database.register(Department, departments)
database.register(Notification, notifications)
database.register(Task, tasks)
database.register(User, users)
database.register(Vacation, vacations)

const plugins = [
  createEntitiesPlugin({
    categories: Category,
    clients: Client,
    departments: Department,
    notifications: Notification,
    tasks: Task,
    users: User,
    vacations: Vacation,
  }),
  VuexORM.install(database),
]
// if(debug) plugins.push(createLogger())


// initial state
const state = {
  offset: 0,
  notify: {},
}

const getters = {
  now: state => moment(new Date((new Date()).valueOf() + state.offset)),
  notify: state => state.notify,
}

const actions = {
  setNow({ commit }, timestamp) {
    commit('NOW', timestamp)
  },
  failed({ dispatch }, failed) {
    const text = failed.errors && failed.errors.length ? failed.errors[0].error : failed.message
    dispatch('notify', new Notification({ type: 'error', text }))
    // if(failed.code == 401) {
    //   // dispatch('auth/unauthorize')
    //   const router = require('./router').getRouter()
    //   router.push('/login')
    // }
  },
  notify({ commit }, notify) {
    commit('NOTIFY', notify)
  },
}

const mutations = {
  NOW(state, timestamp) {
    state.offset = (new Date()).valueOf() - Date.parse(timestamp)
  },
  NOTIFY(state, notify) {
    state.notify = notify
  },
}

import auth from './modules/auth'
import webpush from './modules/webpush'
import traffic from './modules/traffic'

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    auth,
    webpush,
    traffic,
  },
  plugins,
  strict: debug,
})

Vue.use(store)

export default store